import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { Stack } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import type { ContentfulImageWithFocus } from "../../../common/types/cmsTypes";
import FullWidthBackground from "../../FullWidthBackground";
import ImageWithFocus from "../ImageWithFocus";
import { type ArticleProps, prefaceFont } from "./Article";
import PublishDate from "./PublishDate";

const StandardArticleHero = ({ article, id }: ArticleProps) => {
   const inspectorProps = useContentfulInspectorMode();
   const headerImage = (article.fields.headerImage as ContentfulImageWithFocus) || undefined;
   const { title, preface } = article.fields;

   return (
      <div className="tw-relative tw-mb-10">
         <FullWidthBackground color="tw-bg-infoBoxBackground" />
         <Stack className="tw-relative tw-w-full md:tw-flex-row tw-py-8 lg:tw-py-16 md:tw-gap-10" gap={4}>
            <Stack justify="center" align="start" className="md:tw-w-1/2 md:tw-gap-8" gap={5}>
               <h1
                  className="tw-text-3xl lg:tw-text-5xl tw-mb-0"
                  {...inspectorProps({
                     entryId: id,
                     fieldId: "title"
                  })}
               >
                  {title}
               </h1>
               <p
                  className={cn(prefaceFont, "tw-mb-0")}
                  {...inspectorProps({
                     entryId: id,
                     fieldId: "preface"
                  })}
               >
                  {preface}
               </p>
               <PublishDate createdAt={article.sys.createdAt} updatedAt={article.sys.updatedAt} className="tw-mb-0" />
            </Stack>
            <div className="md:tw-w-1/2">
               {headerImage && (
                  <div className="">
                     <ImageWithFocus
                        width={1250}
                        ratio="3x2"
                        key={headerImage.sys.id}
                        entryId={headerImage.sys.id}
                        placement="aboveFold"
                        className="tw-rounded-md tw-object-cover"
                        {...inspectorProps({
                           entryId: id,
                           fieldId: "headerImage"
                        })}
                        imageFromParent={headerImage}
                     />
                  </div>
               )}
            </div>
         </Stack>
      </div>
   );
};

export default StandardArticleHero;
